
import * as React from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, Card, makeStyles, DataGridCell } from '@fluentui/react-components';
import { cedarModules } from '../modules';
import { useSidebarEffect } from '../contexts/SidebarContext';

const useStyles = makeStyles({
  card: { border: 'none' },
  iconWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  iconImg: { width: '24px', height: '24px', marginBottom: '8px' },
  iconNode: { width: '24px', height: '24px', },
});

const DashboardPage: React.FC = () => {
  const classes = useStyles();
  
  // Make sidebar invisible for dashboard
  useSidebarEffect('invisible');
  
  return (
    <Card className={`pkCard ` + classes.card}>
      <h2>Dashboard</h2>
      <List navigationMode="composite" style={{ display: 'flex', gap: '20px' }}>
        {cedarModules.map((module) => (
          <ListItem key={module.key}>
            <DataGridCell>
              <Link to={module.routes?.[0]?.href || '/'}>
                <div className={classes.iconWrapper}>
                  {module.domain.icon ? (
                    typeof module.domain.icon === 'string' ? (
                      <img src={module.domain.icon} alt={module.domain?.title ?? ''} className={classes.iconImg} />
                    ) : React.isValidElement(module.domain.icon) ? (
                      <span className={classes.iconNode}>{module.domain.icon}</span>
                    ) : (
                      React.createElement(module.domain.icon as unknown as React.ComponentType<{ className?: string; 'aria-hidden'?: boolean }>, { className: classes.iconNode, 'aria-hidden': true })
                    )
                  ) : null}
                  <span>{module.name}</span>
                </div>
              </Link>
            </DataGridCell>
          </ListItem>
        ))}
      </List>
    </Card >
  );
};

export default DashboardPage;
